import { useEffect } from 'react';
import reframe from 'nike-re-framejs';

function useCashinOffer() {
    useEffect(() => {
        reframe.dispatch(['ticketus/cashin-offer/subscribe']);
        return () => {
            reframe.dispatch(['ticketus/cashin-offer/unsubscribe']);
        };
    }, []);
}

export default useCashinOffer;
